// src/api/verificationAdminApi.ts
import client from "./client";

export type VerificationDocumentType =
  | "IDENTITY"
  | "SELFIE"
  | "RUT"
  | "CHAMBER_OF_COMMERCE";

export type VerificationDocumentStatus =
  | "PENDING_UPLOAD"
  | "PENDING_REVIEW"
  | "APPROVED"
  | "REJECTED"
  | "EXPIRED";

export interface VerificationDocumentAdminItem {
  id: string;
  documentTypeCode: VerificationDocumentType;
  documentTypeLabel: string;
  status: VerificationDocumentStatus;
  uploadedAt: string;
  reviewedAt?: string | null;
  rejectionReason?: string | null;
  downloadUrl?: string | null;
  userId: string;
  userFullName: string;
}

interface AdminEnvelope<T> {
  code: number;
  message: string;
  content: T;
  totalElements?: number;
  totalPages?: number;
}

export const verificationAdminApi = {
  listar: (
    page = 0,
    size = 20,
    status?: VerificationDocumentStatus | "",
    type?: VerificationDocumentType | "",
  ) =>
    client.get<AdminEnvelope<VerificationDocumentAdminItem[]>>(
      "/api/v1/admin/verifications",
      { params: { page, size, status: status || undefined, type: type || undefined } },
    ),

  aprobar: (id: string) =>
    client.patch<AdminEnvelope<VerificationDocumentAdminItem>>(
      `/api/v1/admin/verifications/${id}/approve`,
    ),

  rechazar: (id: string, reason: string) =>
    client.patch<AdminEnvelope<VerificationDocumentAdminItem>>(
      `/api/v1/admin/verifications/${id}/reject`,
      { reason },
    ),
};
